import React, { useEffect } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { CheckoutSection } from '../components/sales/CheckoutSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalCtaSection } from '../components/sales/FinalCtaSection';
import { SiteFooter } from '../components/sales/SiteFooter';
import { StickyMobileCta } from '../components/StickyMobileCta';
export function SalesPage() {
  useEffect(() => {
    document.documentElement.lang = 'fr';
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-148" data-mp="3qoglsydl4mcf">
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-149" data-mp="3vmrtp3kbkms0">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-150" data-mp="3ajq7im9m7v46">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-151" data-mp="3aljddzcembb4">
            Makeup Instructor <span className="text-brand-gold" data-id="element-152" data-mp="30tdmyu1sw1y1">Ready</span>
          </p>
        </div>
      </header>

      <main data-id="element-153" data-mp="2vvc4obc786nm">
        <HeroSection data-id="element-154" data-mp="2vvvfl83flus5" />
        <InsideSection data-id="element-155" data-mp="2vweyos4tip7r" />
        <VolumesSection data-id="element-156" data-mp="2vszexc078s00" />
        <BonusesSection data-id="element-157" data-mp="3tj46jim7bw1j" />
        <AudienceSection data-id="element-158" data-mp="3thjbzszw0d3o" />
        <CheckoutSection data-id="element-159" data-mp="3tht1zgkxmk9d" />
        <FaqSection data-id="element-160" data-mp="3ojhsx82gods7" />
        <FinalCtaSection data-id="element-161" data-mp="3oizqftp7h3bu" />
      </main>

      <SiteFooter data-id="element-162" data-mp="3ok0zjsmnvfqx" />
      <StickyMobileCta data-id="element-163" data-mp="3ohewa56szmei" />
    </div>;
}